<template>
  <div class="statistics">
    <div class="statistics-header">
      <el-date-picker
        v-model="searchForm.createTimeStart"
        type="date"
        placeholder="选择开始时间"
        value-format="timestamp"
      />
      <el-date-picker
        v-model="searchForm.createTimeEnd"
        type="date"
        placeholder="选择开始时间"
        value-format="timestamp"
      />
    </div>
    <tabContent
      :panel-data="result"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import tabContent from './panel/index.vue';

export default {
  name: 'Home',
  components: {
    tabContent,
  },
  data() {
    return {
      searchForm: {
        createTimeStart: null,
        createTimeEnd: null,
      },
      result: {
        evaluationOrderAmount: [], evaluationOrderCount: [], agencyOrderCount: [],
      },
    };
  },
  watch: {
    searchForm: {
      handler() {
        this.getHomePageStatistics();
      },
      deep: true,
    },
  },
  mounted() {
    this.getHomePageStatistics();
  },
  methods: {
    // 获取列表
    async getHomePageStatistics() {
      const evaluationOrderAmount = await axClient.evaluation.listSummaryByEvaluationOrderAmount(this.searchForm);
      const evaluationOrderCount = await axClient.evaluation.listSummaryByEvaluationOrderCount(this.searchForm);
      const agencyOrderCount = await axClient.evaluation.listSummaryByAgencyOrderCount(this.searchForm);
      this.result = {
        evaluationOrderAmount,
        evaluationOrderCount,
        agencyOrderCount,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics{
  padding-top: 10px;
  .statistics-header{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .el-date-editor{
      max-width: 150px;
      margin-left: 20px;
    }
  }
}
</style>
